(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-result/assets/javascripts/result-coupon.js') >= 0) return;  svs.modules.push('/components/tipsen/route-result/assets/javascripts/result-coupon.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const Paper = svs.ui.ReactPaper;
const useDrawSubscription = svs.components.sport.drawsRedux.hooks.useDrawSubscription;
const _svs$components$tipse = svs.components.tipsen.routeResult,
  CouponHolderFallback = _svs$components$tipse.CouponHolderFallback,
  NetSales = _svs$components$tipse.NetSales;
const CouponStatic = svs.components.tipsen.couponStatic.CouponStatic;
const _svs$components$tipse2 = svs.components.tipsen.routeResult,
  ResultsDrawSelector = _svs$components$tipse2.ResultsDrawSelector,
  ResultSettings = _svs$components$tipse2.ResultSettings;
const formatDate = svs.components.lbUtils.helpers.formatDate.formatDate;
const RenderProvider = svs.component.tipsen.renderContext.RenderProvider;
const pageTypes = svs.component.tipsen.renderContext.constants.pageTypes;
const DrawSubscriberLight = _ref => {
  let productId = _ref.productId,
    drawNumber = _ref.drawNumber;
  useDrawSubscription(drawNumber, productId, {
    isLightUpdate: true
  });
  return null;
};
const ResultCoupon = _ref2 => {
  let currentDateDraws = _ref2.currentDateDraws,
    isLoadingFetchDate = _ref2.isLoadingFetchDate,
    draw = _ref2.draw,
    drawResults = _ref2.drawResults;
  if (isLoadingFetchDate) {
    return React.createElement(Paper, {
      branding: "sport",
      className: "result-coupon"
    }, React.createElement(CouponHolderFallback, null));
  }
  const renderCoupon = () => {
    if (!draw || !drawResults) {
      return React.createElement(CouponHolderFallback, null);
    }
    const _drawResults = _slicedToArray(drawResults, 4),
      drawIsCancelled = _drawResults[3];
    return React.createElement("section", {
      "aria-label": "Kupong med resultat"
    }, drawIsCancelled && React.createElement("h1", {
      className: "drawIsCancelled-text"
    }, "Inst\xE4lld omg\xE5ng"), React.createElement(DrawSubscriberLight, {
      drawNumber: draw.drawNumber,
      productId: draw.productId
    }), React.createElement(CouponStatic, {
      alwaysIncludeParams: true,
      draw: draw,
      drawEvents: draw.drawEvents,
      drawIsCancelled: drawIsCancelled,
      drawNumber: draw.drawNumber,
      drawResults: drawResults[0],
      productId: draw.productId,
      sportType: draw.sportType
    }), React.createElement(NetSales, {
      currencyCounterUniqueId: draw.drawNumber,
      currentNetSale: draw.currentNetSale,
      drawIsCancelled: drawIsCancelled
      ,
      key: draw.drawNumber
    }), (draw === null || draw === void 0 ? void 0 : draw.regCloseTime) && React.createElement("div", {
      className: "pg_result_betstop f-550"
    }, "Spelstopp ".concat(formatDate(draw.regCloseTime, true, true, false))));
  };
  return React.createElement(RenderProvider, {
    pageType: pageTypes.RESULT
  }, React.createElement(ResultSettings, null), React.createElement(Paper, {
    branding: "sport",
    className: "result-coupon"
  }, React.createElement(ResultsDrawSelector, {
    draws: currentDateDraws,
    selectedDraw: "".concat(draw === null || draw === void 0 ? void 0 : draw.drawNumber, "-").concat(draw === null || draw === void 0 ? void 0 : draw.productId)
  }), renderCoupon()));
};
setGlobal('svs.components.tipsen.routeResult.ResultCoupon', ResultCoupon);

 })(window);